import { CarLightHighIcon } from './CarLightHighIcon';

/**
 * author: Michael Irigoyen
 * id 7EF72FB8-3767-495E-9F80-888F6924B856
 * name car-light-high
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-light-high.svg
 * tags
 * - Automotive 
 */
export const HeadLightHighIcon = CarLightHighIcon;
export default HeadLightHighIcon